import React, { Component } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { fetchClientImportTemplates } from '../../../services/clinicPortalServices/clientImportTemplateService';
import { Button, Modal } from 'react-bootstrap';
// import 'ag-grid-community/styles/ag-grid.css';
// import 'ag-grid-community/styles/ag-theme-alpine.css';
import { ThemeContext } from '../../../theme/ThemeProvider';
import { colorSchemeDark, colorSchemeLight, themeQuartz } from 'ag-grid-community';
import { getTestById, searchTests } from '../../../services/clinicPortalServices/testService';
import { manualResult } from '../../../services/clinicPortalServices/resultImportService';
import toastr from 'toastr';

const themeLight = themeQuartz.withPart(colorSchemeLight);
const themeDark = themeQuartz.withPart(colorSchemeDark);

export default class ManualResult extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showManualResultPopup: false,
            template: null,
            gridColumns: [],
            gridRows: [],
            loading: true
        };
    }

    componentDidMount() {
        this.loadTemplateAndSetupGrid();
    }

    async loadTemplateAndSetupGrid() {
        let currentResultValues = this.props.data.results?.values || [];
        let allAnalytes = this.props.allAnalytes || [];
        const resp = await fetchClientImportTemplates();
        const templates = resp?.data || [];
        // Find template that includes this testId
        const { test_id, test_info } = this.props.data || {};
        const template = templates.find((t) => (t.associatedTests.map((test) => test._id) || []).includes(test_id._id));
        if (!template) {
            this.setState({ loading: false });
            return;
        }
        // Columns: required or manualEntry, sorted by mapTo value
        const columnOrder = ['sample', 'sampleType', 'analyteName', 'analyteResult', 'analyteUnits', 'analyteArea'];
        const columns = (template.columnMappings || [])
            .filter((col) => col.validation?.required || col.manualEntry?.enabled)
            .map((col) => ({
                headerName: col.sourceColumnName + (col.validation?.required ? ' *' : ''),
                field: col.systemColumnField,
                editable: ['sample', 'analyteName'].includes(col.systemColumnField) ? false : true,
                flex: 1,
                minWidth: 120,
                systemColumnField: col.systemColumnField
            }))
            .sort((a, b) => {
                const aIndex = columnOrder.indexOf(a.systemColumnField);
                const bIndex = columnOrder.indexOf(b.systemColumnField);
                // If both are in the order array, sort by their position
                if (aIndex !== -1 && bIndex !== -1) {
                    return aIndex - bIndex;
                }
                // If only one is in the order array, it comes first
                if (aIndex !== -1) return -1;
                if (bIndex !== -1) return 1;
                // If neither is in the order array, maintain original order
                return 0;
            });
        const testDetailsResponse = await getTestById(test_id._id);
        const testDetails = testDetailsResponse?.data || {};
        let analyteIds = testDetails.analyteIds || [];
        if (testDetails.isPanel) {
            analyteIds = testDetails.testIds.map((test) => test.analyteIds).flat();
        }
        const gridRows = template.analyteMappings
            .filter((analyteMapping) => analyteIds?.includes(analyteMapping.systemAnalyteId))
            .map((analyteMapping) => {
                let matchingAnalyte = allAnalytes.find((item) => item._id === analyteMapping.systemAnalyteId);
                let matchingResult = currentResultValues.find(
                    (result) => result.analyteId === analyteMapping.systemAnalyteId
                );
                const row = {};
                columns.forEach((col) => {
                    switch (col.field) {
                        case 'sample':
                            row[col.field] = test_info?.sample || ''; // Assuming sample_id is passed in data prop
                            break;
                        case 'analyteName':
                            row[col.field] = matchingAnalyte.name || analyteMapping.sourceAnalyte || '';
                            break;
                        case 'analyteUnits':
                            row[col.field] = analyteMapping.analyteUnits || analyteMapping.units || '';
                            break;
                        case 'analyteResult':
                            row[col.field] = matchingResult?.analyteResult || '';
                            break;
                        default:
                            row[col.field] = '';
                            break;
                        // case
                    }
                });
                return row;
            });
        this.setState({ template, gridColumns: columns, gridRows, loading: false });
    }

    onCellValueChanged = (params) => {
        const updatedRows = [...this.state.gridRows];
        updatedRows[params.node.rowIndex][params.colDef.field] = params.newValue;
        this.setState({ gridRows: updatedRows });
    };

    handleSaveResult = () => {
        const manualResultInfo = {
            orderId: this.props.data._id,
            testId: this.props.data.test_id._id,
            results: this.state.gridRows
        };

        manualResult(manualResultInfo).then((res) => {
            if (res && res.success) {
                toastr.success('Manual result saved successfully');
                this.props.handleCloseManualResult(true);
            }
        });
    };

    render() {
        if (this.state.loading) return <div className="p-3">Loading...</div>;
        return (
            <>
                <Modal.Body>
                    {!this.state.template ? (
                        <div>No template found for this test.</div>
                    ) : (
                        <ThemeContext.Consumer>
                            {({ themeName }) => (
                                <div
                                    id="myGrid"
                                    style={{
                                        height: 'calc(100vh - 400px)',
                                        width: '100%'
                                    }}
                                >
                                    <AgGridReact
                                        columnDefs={this.state.gridColumns}
                                        rowData={this.state.gridRows}
                                        theme={themeName === 'Light' ? themeLight : themeDark}
                                        onCellValueChanged={this.onCellValueChanged}
                                        defaultColDef={{
                                            resizable: true,
                                            sortable: true,
                                            filter: true
                                        }}
                                        suppressScrollOnNewData={true}
                                        suppressAnimationFrame={true}
                                        maintainColumnOrder={true}
                                        // stopEditingWhenCellsLoseFocus={true}
                                        suppressMovableColumns={true}
                                        singleClickEdit={true}
                                    />
                                </div>
                            )}
                        </ThemeContext.Consumer>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={this.props.handleCloseManualResult}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={this.handleSaveResult}>
                        Save Result
                    </Button>
                </Modal.Footer>
            </>
        );
    }
}
